import React from "react";
import featuredImg from "../../Images/Rectangle 20 (2).png";
import "./BlogLandingSections.css"
import BlogPost from "./BlogPost";

const BlogLandingSections = () => {
  return (
    <>
      {/* Categories */}

      <section className="blog-categories-blue">
        <button>Market Trends</button>
        <button>Investment</button>
        <button>Property News</button>
        <button>Buying Guide</button>
        <button>Rental Insights</button>
        <button>Luxury Homes</button>
      </section>

      {/* Featured Blog */}

      <section className="featured-blog-blue">
        <div className="featured-blog-image-blue">
          <img src={featuredImg} alt="" />
        </div>

        <div className="featured-blog-content-blue">
          <span>Featured Article</span>

          <h2>
            Gurgaon Property Market Outlook
            For 2026
          </h2>

          <p>
            Explore upcoming investment opportunities,
            price trends, rental growth and emerging
            sectors driving Gurgaon, Noida and Delhi NCR
            real estate markets.
          </p>

          <button>
            Read Full Article
          </button>
        </div>
      </section>

      {/* Stats */}

      <section className="blog-stats-blue">

        <div>
          <h3>500+</h3>
          <p>Articles Published</p>
        </div>

        <div>
          <h3>50K+</h3>
          <p>Monthly Readers</p>
        </div>

        <div>
          <h3>100+</h3>
          <p>Market Reports</p>
        </div>

        <div>
          <h3>20+</h3>
          <p>Industry Experts</p>
        </div>

      </section>

      {/* Recent Posts Header */}

      <section className="recent-post-header-blue">

        <span>Latest Updates</span>

        <h2>
          Recent Real Estate Articles
        </h2>

        <p>
          Discover expert insights, investment strategies,
          property market trends and buyer guides.
        </p>

      </section>
        <BlogPost />
    </>
  );
};

export default BlogLandingSections;